export const JsInjectionModeDtoDescriptions = {
  type: "Execution timing for injected JS. When 'timeout', the timeout field specifies the delay.",
  timeout:
    "Delay in milliseconds before JS execution. Only relevant when type is 'timeout'.",
} as const;

export const OnsiteInjectionDtoDescriptions = {
  _schema:
    "Onsite injections add CSS/JS to the page — use for ALL visual styling changes (colors, backgrounds, fonts, borders, layout, visibility, etc.) and custom behavior. When making CSS-only changes, use ONLY this field and leave onsiteEdits as an empty array. For DOM content changes (text, images, HTML), use onsiteEdits instead.",
  id: "Server-generated. Read-only.",
  variationId: "References the parent variation.",
  customCss: "CSS injected globally on the page when this variation is active.",
  customJs:
    "JavaScript executed on the page. Execution timing controlled by jsInjectionMode.",
  jsInjectionMode:
    "Controls when customJs runs: immediately on load, after window load, or after a configurable delay.",
  source: "Where the injection was created.",
} as const;

export const CreateOnsiteInjectionDtoDescriptions = {
  _schema:
    "Creates a CSS/JS injection. Use for ALL visual styling changes (colors, backgrounds, fonts, layout, etc.) and custom JS behavior. When the change is purely CSS-based, use ONLY this field and leave onsiteEdits as an empty array. For DOM content changes (text, images, HTML), use onsiteEdits instead.",
  id: "Omit to auto-generate.",
  customCss: "CSS injected globally on the page for this variation.",
  customJs: "JavaScript to execute. Timing controlled by jsInjectionMode.",
  jsInjectionMode:
    "When to execute customJs. Set timeout field when using 'timeout' mode.",
} as const;

export const ExternalOnsiteInjectionDescriptions = {
  id: "Copy from GET response. Identifies which injection to update.",
  variationId: "Copy from GET response. Must match the parent variation's id.",
} as const;
